import { Modal } from 'components/Modal'
import { CheckIcon } from '@heroicons/react/outline'

interface Props {
  open: boolean
  onConfirm: () => void
  onClose: () => void
}

export function FinalizeInvoiceModal({ open, onConfirm, onClose }: Props) {
  return (
    <Modal open={open} title="Finalizar fatura" onClose={onClose}>
      <div className="flex flex-col gap-4 pr-4 mt-4">
        <p className="text-sm text-gray-600">
          A fatura será marcada como{' '}
          <span className="font-semibold text-gray-900">aberta</span> e ficará
          disponível para pagamento pelo cliente.
        </p>
        <p className="text-sm text-gray-600">
          Use esta ação quando a fatura estiver em rascunho e pronta para ser
          enviada — por exemplo, após uma regeneração manual.
        </p>
        <div className="flex justify-end gap-3 mt-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-transparent bg-emerald-600 text-sm font-medium text-white hover:bg-emerald-700 focus:outline-none"
          >
            <CheckIcon className="h-4 w-4" />
            Finalizar
          </button>
        </div>
      </div>
    </Modal>
  )
}
